const easing = {
  easeOutCubic: function (pos: number) {
    return Math.pow(pos - 1, 2) + 1;
  },
  easeOutQuart: function (pos: number) {
    return -(Math.pow(pos - 1, 2) - 1);
  },
};

export default easing;
